module.exports = __webpack_public_path__ + "static/media/hover.3241ff98.png";